export const LOAD_EXPRESS_DATA_REQUEST =
  "gaq/Express/LOAD_EXPRESS_DATA_REQUEST";
export const LOAD_EXPRESS_DATA_SUCCESS =
  "gaq/Express/LOAD_EXPRESS_DATA_SUCCESS";
export const LOAD_EXPRESS_DATA_FAILURE =
  "gaq/Express/LOAD_EXPRESS_DATA_FAILURE";
export const RESET_EXPRESS_STATE = "gaq/Express/RESET_EXPRESS_STATE";
